import React from "react";
import Button from "../../components/EmptyButton";
import { FaBookOpen, FaBriefcase, FaUsers } from "react-icons/fa";

const ServicesSection = () => {
  const services = [
    {
      icon: FaBookOpen,
      title: "Study Materials",
      description:
        "Simple and concise study resources created by top graduates from US and UK universities who took the same courses as you.",
      features: [
        "Revision Notes",
        "Model Essays",
        "Tutorial Videos",
        "Practice Questions",
      ],
    },
    {
      icon: FaUsers,
      title: "Tutoring Sessions",
      description:
        "Get personalized support through one-on-one tutoring sessions to maximize your chances of getting high grades.",
      features: [
        "1-on-1 Sessions",
        "Group Tutoring",
        "Exam Preparation",
        "Assignment Help",
      ],
    },
    {
      icon: FaBriefcase,
      title: "Career Advice",
      description:
        "Receive mentoring and guidance to build a high income career with your degree from experienced professionals.",
      features: [
        "Career Planning",
        "CV Review",
        "Interview Prep",
        "Industry Insights",
      ],
    },
  ];

  return (
    <section id="services-section" className="py-0 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center space-y-4 mb-16">
          <h2
            className="font-bold text-foreground"
            style={{ fontSize: "3rem" }}
          >
            Get Wide Variety of Simple Study Materials
          </h2>
          <p
            className="text-muted-foreground max-w-3xl mx-auto"
            style={{ fontSize: "1.225rem", color: "#78726d" }}
          >
            All specifically designed for you to get top grades in the simplest
            way possible
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">
          {services.map((service, index) => (
            <div
              key={index}
              className="relative rounded-xl pb-6 group hover:shadow-floating transition-all duration-300 border bg-gradient-card backdrop-blur-sm" style={{borderColor: 'lightgray'}}
            >
              <div className="space-y-4 p-6">
                <div className="w-full h-full bg-gradient-hero rounded-lg flex justify-left group-hover:scale-110 transition-transform duration-300">
                  <service.icon
                    className="text-primary-foreground text-primary"
                    style={{ fontSize: "3rem" }}
                  />
                </div>

                <div className="text-foreground" style={{fontWeight: '700', fontSize: '1.25rem'}}>
                  {service.title}
                </div>
              </div>
              <div className="space-y-6 px-6">
                <div className="text-muted-foreground text-base leading-relaxed" style={{fontSize: '1rem', color: '#78726d'}}>
                  {service.description}
                </div>

                <div className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <div
                      key={featureIndex}
                      className="flex items-center space-x-2"
                    >
                      <div className="w-2 h-2 bg-primary rounded-full"></div>
                      <span className="text-sm text-foreground">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center text-center mt-12">
          <div className="w-72">
            <Button
              filled={true}
              className="text-lg px-8 py-2"
              onClick={() => window.open("https://studycrowd.ai/login", "_blank")}
            >
              Sign Up to Get Started
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
